
  export const contractAddress = "0x3e422faD94ffe9eF680AAE19bF7158B61F94f64f"
  export const ownerAddress = "0x3d7E33057C0822eAD645E8F8aceE30EA34075356"
  export const networkDeployedTo = "11155111"
  